/** FHIR tag systems used on DocumentReference for provenance in PHC. */
export const FHIR_DOCUMENT_TYPE_TAG_SYSTEM =
  'http://lifeomic.com/fhir/document-type';

export const MEMBER_UPLOADED_FILE_DOCUMENT_TYPE = 'member-uploaded-file';

/**
 * Returns true when a DocumentReference represents a member-uploaded file
 * (as opposed to clinician or system sources). Used to gate delete in PHC.
 *
 * Member uploads are identified by the document-type tag surfaced in the
 * member document table's Type column.
 */
export function isMemberUploadedPatientDocument(
  resource: fhir.Resource | null | undefined,
): boolean {
  if (!resource || resource.resourceType !== 'DocumentReference') {
    return false;
  }
  const doc = resource as fhir.DocumentReference;

  return (
    doc.meta?.tag?.some(
      tag =>
        tag.system === FHIR_DOCUMENT_TYPE_TAG_SYSTEM &&
        tag.code === MEMBER_UPLOADED_FILE_DOCUMENT_TYPE,
    ) ?? false
  );
}
